<template>
  <div class="jobs-container">
  <div>Jobs</div>
  <ul v-for="item of rssfeed" :key="item.guid">
    <li>
      <div>Published on {{item.pubDate}}</div>
      <a v-bind:href="item.link" target="_blank">{{item.title}}</a>
    </li>
  </ul>
  </div>
</template>

<script>
import Parser from 'rss-parser'

export default {
  data () {
    return {
      rssfeed: null
    }
  },
  beforeMount () {
    this.$store.commit('setActualRoute', this.$route.name)
  },
  mounted () {
    const parser = new Parser()
    const url = 'https://cors-anywhere.herokuapp.com/http://careers.stackoverflow.com/jobs/feed?m=Student&mxs=Junior&sort=newest'
    this.$store.commit('setBannerTitle', 'Jobs list!')
    parser.parseURL(url).then(feed => {
      this.rssfeed = feed.items
    })
  }
}
</script>

<style scoped>
.jobs-container {
    font-family: "ModeSeven";
    font-size: 1.25em;
    padding-right: 20px;
}
</style>
